import { Component, OnChanges, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { NgbDate, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { DateRangeQuery } from './date-range-query';
import { Subject } from 'rxjs';
import { RangePresetParam, CustomRangeParam} from "../../../domain/stats";
import { SiteService } from "../../../services/site/site.service";
import {DateRange, ProgramSite} from "../../../domain/cloud-topology";
import {takeUntil} from "rxjs/operators";

@Component({
    selector: 'app-range-selector',
    templateUrl: './range-selector.component.html',
    styleUrls: ['./range-selector.component.css'],
    standalone: false
})
export class RangeSelectorComponent implements OnChanges {

  @Input() sites: ProgramSite[] | null;
  @Input() timezone: string;
  @Output() paramEvent = new EventEmitter<RangePresetParam | CustomRangeParam>();

  preset: string;
  displayedPreset: string;
  params: RangePresetParam | CustomRangeParam;
  dateRanges: DateRange[];
  isBillingCollapsed: boolean;

  @ViewChild(DatepickerComponent, { static: true }) datePicker;

  constructor(private modalService: NgbModal,
              private siteService: SiteService,
              private router: Router,
              private route: ActivatedRoute) { }

  ngOnChanges() {
    if (this.sites) {
      this.applyPresetToRoute();
    }
  }

  applyPresetToRoute(): void {
    const queryParamsCompleted$ = new Subject<void>();
    this.route.queryParams.pipe(takeUntil(queryParamsCompleted$)).subscribe(params => {
      if (params.rangePreset) {
        this.changePresetRange(params.rangePreset);
      } else if (params.startDate && params.stopDate) {
        this.customRange(params.startDate, params.stopDate);
      } else {
        this.changePresetRange('currentWindow');
      }
      queryParamsCompleted$.next();
      queryParamsCompleted$.complete();
    });
  }

  changePresetRange(preset: string, dr?: DateRange) {
    this.preset = preset;
    switch (this.preset) {
      case 'currentWindow':
        this.applyPreset( 'Current' );
        break;
      case 'lastDay':
        this.applyPreset('Last day');
        break;
      case 'last3days':
        this.applyPreset('Last 3 days');
        break;
      case 'lastWeek':
        this.applyPreset('Last week');
        break;
      case 'customRange':
        this.modalOpen(this.datePicker.modalContent);
        break;
      case 'billingPeriod':
        this.selectPeriod(dr);
        break;
    }
  }

  modalOpen(content) {
    this.modalService.open(content, {ariaLabelledBy: 'popup-title'}).result.then(() => {
      if (this.datePicker.to) {
        this.customRange(this.datePicker.from, this.datePicker.to);
      } else {
        this.customRange(this.datePicker.from, this.datePicker.from);
      }
    }, () => {
    });
  }

  applyPreset(display: string) {
    this.displayedPreset = display;
    this.params = {rangePreset: this.preset};
    this.paramEvent.emit(this.params);
    this.router.navigate([], {relativeTo: this.route,
      queryParams: {rangePreset: this.preset, startDate: null, stopDate: null}, queryParamsHandling: 'merge'});
  }

  selectPeriod(dr: DateRange) {
    this.isBillingCollapsed = true;
    this.customRange(dr.start, dr.stop);
  }

  customRange(start: string | NgbDate, stop: string | NgbDate) {
    const startDisplay = DateRangeQuery.startDisplayString(start);
    const stopDisplay = DateRangeQuery.stopDisplayString(stop);

    this.displayedPreset =  startDisplay + ' to ' + stopDisplay;
    this.params = {startDate: DateRangeQuery.startQueryString(start, this.timezone), stopDate: DateRangeQuery.stopQueryString(stop, this.timezone, DateRangeQuery.isSingleCustomDateRange(start, stop, this.timezone))};
    this.paramEvent.emit(this.params);
    this.router.navigate([], {relativeTo: this.route,
      queryParams: {rangePreset: null, startDate: startDisplay, stopDate: stopDisplay}, queryParamsHandling: 'merge'});
  }

}
